import { getRequest, postRequest } from '../../methods';

const settingsIntegrationGetMcpApplications = () =>
  getRequest('settings/integrations/mcp_applications');

const settingsIntegrationGetMcpApplication = (id: number) =>
  getRequest(`settings/integrations/mcp_applications/${id}`);

const settingsIntegrationCreateMcpApplication = (payload: { name: string }) =>
  postRequest('settings/integrations/mcp_applications', {
    mcpApplication: payload,
  });

const mcp = {
  settingsIntegrationGetMcpApplications,
  settingsIntegrationGetMcpApplication,
  settingsIntegrationCreateMcpApplication,
};

export default mcp;
